exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrollable[data-v-b730ab20]{max-height:350px;overflow-y:scroll}ul[data-v-b730ab20]{list-style-type:none;padding:35px;max-width:68%;margin-left:auto;margin-right:auto}li[data-v-b730ab20]{padding:10px;box-shadow:0 0 2px gray}", ""]);

// exports
